import React, { ReactNode, useState } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import NavigationBack from '~/components/molecules/navigation/NavigationBack'
import NavigationHeaderTitle, { NavigationTitleProps } from '~/components/molecules/navigation/NavigationHeaderTitle'
import { ColorWeight, lightenColor } from '~/common/define/color'
import SlideToggle from '~/components/utils/animation/SlideToggle'
import NavigationBorderFrame from '~/components/molecules/navigation/NavigationBorderFrame'

interface Props {
  mainTitleProps: NavigationTitleProps
  subTitlePros?: NavigationTitleProps
  subNode?: ReactNode
}

const NavigationHeader = ({mainTitleProps, subTitlePros = null, subNode = null}: Props) => {
  const [hovered, setHovered] = useState<boolean>(false)
  const [backHovered, setBackHovered] = useState<boolean>(false)

  return (
    <>
      <div
        className={styles.header}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {subTitlePros &&
          <>
            <div
              onMouseEnter={() => setBackHovered(true)}
              onMouseLeave={() => setBackHovered(false)}
              >
              <NavigationBack
                {...subTitlePros}
                hovered={backHovered}
              />
            </div>
            <span className={styles.header__sub}>
              <SlideToggle show={hovered} forceSlideIn={true}>
                <span
                  onMouseEnter={() => setBackHovered(true)}
                  onMouseLeave={() => setBackHovered(false)}
                >
                  <NavigationHeaderTitle {...subTitlePros} hovered={backHovered}/>
                </span>
                <NavigationBorderFrame borderColor={subTitlePros.color} bottom>
                  {subNode}
                </NavigationBorderFrame>
              </SlideToggle>
            </span>
            <style jsx>{`
              span {
                background-color: ${lightenColor(subTitlePros.color, ColorWeight.FEATHER)};
              }
            `}</style>
          </>
        }
      </div>
      <NavigationHeaderTitle {...mainTitleProps}/>
    </>
  )
}

export default NavigationHeader